export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-08A.593319fd.png";